export default __webpack_public_path__ + "static/media/gg4.b0c64119.jpeg";